import { DropDownItem } from "../models/key-value";

export class RoleNames {
  public static readonly Administrator = "Administrator";
  public static readonly Staff = "Staff";
  public static readonly Supervisor = "Supervisor";
  public static readonly Atm = "Atm";
  public static readonly Manager = "Manager";
  public static readonly Partner = "Partner";
  public static readonly PartnerStaff = "PartnerStaff";
  public static readonly Investor = "Investor";
}

/** Role sets used by the sidebar and the route guards (keep both in sync). */
export class RoleGroups {
  public static readonly AdminManager = [
    RoleNames.Administrator,
    RoleNames.Manager,
  ];
  public static readonly AdminManagerSupervisor = [
    RoleNames.Administrator,
    RoleNames.Manager,
    RoleNames.Supervisor,
  ];
  public static readonly Partners = [RoleNames.Partner, RoleNames.PartnerStaff];
  public static readonly Overview = [
    ...RoleGroups.AdminManagerSupervisor,
    ...RoleGroups.Partners,
  ];
  public static readonly Operations = [
    ...RoleGroups.AdminManagerSupervisor,
    RoleNames.Staff,
    ...RoleGroups.Partners,
  ];
  /** Backend AdminAndPartner (Investors, WithdrawalRequests, CommissionConfig/rates, PartnerStaff). */
  public static readonly AdminPartner = [
    RoleNames.Administrator,
    RoleNames.Partner,
  ];
  /** Backend AdminAndPartners (TransactionCommission). */
  public static readonly AdminPartners = [
    RoleNames.Administrator,
    RoleNames.Partner,
    RoleNames.PartnerStaff,
  ];
  /** Roles that may create, edit and delete tickets. */
  public static readonly TicketManagers = [
    ...RoleGroups.AdminManagerSupervisor,
    ...RoleGroups.Partners,
  ];
}

export class UIConstants {
  public static readonly TicketStatus: DropDownItem[] = [
    {
      id: "0",
      value: "Pending",
    },
    {
      id: "1",
      value: "Resolved",
    },
  ];
  public static readonly LogTypes: DropDownItem[] = [
    {
      id: "0",
      value: "Start",
    },
    {
      id: "1",
      value: "Error",
    },
    {
      id: "2",
      value: "Cancel",
    },
    {
      id: "3",
      value: "Back",
    },
    {
      id: "4",
      value: "SelectLanguage",
    },
    {
      id: "5",
      value: "Next",
    },
    {
      id: "6",
      value: "MtnMoney",
    },
    {
      id: "7",
      value: "Orange",
    },
    {
      id: "8",
      value: "Crypto",
    },
    {
      id: "9",
      value: "IdCard",
    },
    {
      id: "10",
      value: "Passport",
    },
    {
      id: "11",
      value: "DrivingLicense",
    },
    {
      id: "12",
      value: "CaptureImage",
    },
    {
      id: "13",
      value: "Deposit",
    },
    {
      id: "14",
      value: "Withdraw",
    },
    {
      id: "15",
      value: "SubmitPhoneNumber",
    },
    {
      id: "16",
      value: "SubmitOtp",
    },
    {
      id: "17",
      value: "ResendOtp",
    },
    {
      id: "18",
      value: "NoteInserted",
    },
    {
      id: "19",
      value: "NoteReturned",
    },
    {
      id: "20",
      value: "NoteAccepted",
    },
    {
      id: "21",
      value: "MtnTransfer",
    },
    {
      id: "22",
      value: "MtnWithdraw",
    },
    {
      id: "23",
      value: "DeviceError",
    },
    {
      id: "24",
      value: "WithdrawCancel",
    },
  ];
  public static readonly StatusItems: DropDownItem[] = [
    {
      id: "true",
      value: "Active",
    },
    {
      id: "false",
      value: "Inactive",
    },
  ];
  public static readonly TransactionType: DropDownItem[] = [
    {
      id: "0",
      value: "Deposit",
    },
    {
      id: "1",
      value: "Withdraw",
    },
  ];

  public static readonly OperatorType: DropDownItem[] = [
    {
      id: "0",
      value: "Mtn",
    },
    {
      id: "1",
      value: "Orange",
    },
    {
      id: "2",
      value: "Crypto",
    },
  ];
  public static readonly StatusType: DropDownItem[] = [
    {
      id: "0",
      value: "Mtn",
    },
    {
      id: "1",
      value: "Orange",
    },
    {
      id: "2",
      value: "Crypto",
    },
  ];

  public static readonly RoleItems: DropDownItem[] = [
    {
      id: RoleNames.Staff,
      value: RoleNames.Staff,
    },
    {
      id: RoleNames.Manager,
      value: RoleNames.Manager,
    },
    {
      id: RoleNames.Supervisor,
      value: RoleNames.Supervisor,
    },
  ];
  public static readonly ExpiryDurationType: DropDownItem[] = [
    {
      id: "0",
      value: "Fixed Duration",
    },
    {
      id: "1",
      value: "Date",
    },
  ];
  public static readonly ExpiryDurations: DropDownItem[] = [
    {
      id: "1",
      value: "1 Month",
    },
    {
      id: "2",
      value: "2 Month",
    },
    {
      id: "3",
      value: "3 Month",
    },
  ];
}
